import AuthorizedPerson from './AuthorizedPerson';

const AuthorizedPersons = ({ users, onEdit, onDelete }) => {

    return (<>
        {users && users.map((user, index) => {
            return <AuthorizedPerson key={index} user={user} index={index} onEdit={onEdit} onDelete={onDelete} />
        })}
    </>
    )
}

export default AuthorizedPersons